import { Component, HostListener } from '@angular/core';
import { GlobalService } from './services/global.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor( public globalService: GlobalService) {}

  @HostListener('click', ['$event']) onClick(event: any) {
    if (event.target.classList.contains('popup-bg')) {
      this.globalService.showTrue = true;
      this.globalService.showPopUp = "";
      document.body ? document.body.classList.remove('no-scroll') : '';
    }
  }
}
